common.View.create('crud::form.inputs.Switch', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initSwitch();
    },

    /**
     * Initializes the switch and prepares it for click events.
     */
    initSwitch()
    {
        // Define elements
        let button = this.element.find('button');
        let span = button.find('span');
        let input = button.find('input');

        // Define classes to switch
        const classes = {
            'button-on': this.element.find('button').data('checked'),
            'button-off': this.element.find('button').data('unchecked'),
            'span-on': this.element.find('button').data('translate'),
            'span-off': 'translate-x-0',
        }

        // If disabled add other classes
        if (input.prop('disabled')) {
            button.addClass('opacity-50 pointer-events-none');
        }

        button.on('click', () => {

            // Check if input isn't disabled
            if (input.prop('disabled')) return;

            // Invert current input value
            const isChecked = !input.prop('checked');
            input.prop('checked', isChecked).val(isChecked ? '1' : '0');

            button.attr('aria-pressed', isChecked ? 'true' : 'false');

            // Trigger change events so they can be listened for elsewhere
            input.trigger('change');
            input.trigger('input');
            input.get(0).dispatchEvent(new Event('input'));

            // Switch classes based on the checked state
            if (isChecked) {
                // "On" state classes
                button.removeClass(classes["button-off"]).addClass(classes["button-on"]);
                span.removeClass(classes["span-off"]).addClass(classes["span-on"]);
            } else {
                // "Off" state classes
                button.removeClass(classes["button-on"]).addClass(classes["button-off"]);
                span.removeClass(classes["span-on"]).addClass(classes["span-off"]);
            }
        });
    },
});
